import { Capacitor } from '@capacitor/core'
import { ImpactStyle, Haptics } from '@capacitor/haptics'

/**
 * Retroalimentación táctil.
 *
 * Solo existe en la app nativa: Safari en iOS no implementa la Vibration API,
 * así que en la versión web esto no hace nada. No es una carencia que se pueda
 * salvar con un truco — es justo una de las razones por las que la app se
 * empaqueta con Capacitor.
 *
 * Todas las llamadas fallan en silencio. Un háptico es un adorno: si el
 * dispositivo no puede darlo, la acción tiene que completarse igual.
 */

export type HapticKind = 'selection' | 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error'

const isNative = Capacitor.isNativePlatform()

export function haptic(kind: HapticKind = 'light'): void {
  if (!isNative) return

  void (async () => {
    try {
      switch (kind) {
        case 'selection':
          await Haptics.selectionStart()
          await Haptics.selectionEnd()
          break
        case 'light':
          await Haptics.impact({ style: ImpactStyle.Light })
          break
        case 'medium':
          await Haptics.impact({ style: ImpactStyle.Medium })
          break
        case 'heavy':
          await Haptics.impact({ style: ImpactStyle.Heavy })
          break
        case 'success':
          await Haptics.notification({ type: 'SUCCESS' as never })
          break
        case 'warning':
          await Haptics.notification({ type: 'WARNING' as never })
          break
        case 'error':
          await Haptics.notification({ type: 'ERROR' as never })
          break
      }
    } catch {
      // Sin háptico disponible; la interacción sigue su curso.
    }
  })()
}
